import { render, staticRenderFns } from "./ProductListIframe.vue?vue&type=template&id=19cfcbd4&"
import script from "./ProductListIframe.vue?vue&type=script&lang=ts&"
export * from "./ProductListIframe.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports